import {SimpleEventsQueryResource} from './simpleEventsQueryResource.model';

export class SimpleEventsEmailResource {
    recipients: string[];
    eventsQueryResource: SimpleEventsQueryResource;
    emailSubject: string;

    constructor(map: SimpleEventsEmailResource = {} as SimpleEventsEmailResource) {
        this.recipients = map.recipients || [];
        this.eventsQueryResource = map.eventsQueryResource || null;
        this.emailSubject = map.emailSubject || null;
    }
}
